import { render, staticRenderFns } from "./laskurini.vue?vue&type=template&id=2d049f9c&"
import script from "./laskurini.vue?vue&type=script&lang=js&"
export * from "./laskurini.vue?vue&type=script&lang=js&"
import style0 from "./laskurini.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports